<template>
    <div class="row mt-2">
        <div class="col-12">
            <div class="form-group">
                <label class="typo__label">
                    {{$t('LAYOUTEDITOR.availableLayoutFormats')}}
                </label>
                <multiselect v-model="selected"
                             :options="options"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="false"
                             :preserve-search="true"
                             :placeholder="$t('UI.pickFormats')"
                             @input="$emit('update:availableFormatsList', $event)"
                             @remove="$emit('update:availableFormatsList', selected)"
                             label="name"
                             track-by="name">
                    <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option.name }} | </span>
                    </span>
                    </template>
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect';

export default {
    name: 'AvailableFormatsSelection',
    data () {
        return {
            selected: this.availableFormatsList || {}
        };
    },
    props: {
        availableFormatsList: {
            type: [Array]
        },
        options: {
            type: [Object, Array]
        }
    },
    components: {
        Multiselect
    }
    
    
};

</script>

<style lang="scss" scoped>

</style>
